import React , {useContext} from 'react'
import CartContext from "../../../../context/cart_context.js";
import "./restBottomSheet.css"
import { Link  , useLocation} from 'react-router-dom';
import {calculateOriginalPrice} from "../../../../functions/mini_func.js";


const RestBottomSheet = () => {
   
 const {cartItems , selectedfoodItemList } = useContext(CartContext);
 var total = 0;
 var totalItems = 0;

 if(selectedfoodItemList.length != 0 ){
     Object.entries(cartItems).forEach(([key, value]) => {
        totalItems = totalItems + value; 
        const item = selectedfoodItemList.find((item) =>  item.dbID == key );
        total = total + calculateOriginalPrice( item.discount  , parseFloat(item.price)  )*value ;
     });
 }

 const location = useLocation();
 const queryParams = new URLSearchParams(location.search);


  return (
    totalItems > 0 &&
     <div className='cart-rest-container' > 
        <div>  { totalItems >1 ? `${totalItems} items\t`  : `${totalItems} item\t`  } |  {"\u{20B9}"} {total} </div>
        <Link  to={`/checkout?${queryParams}`}>
         <button>View Cart</button>
        </Link>
    </div>
  )
}

export default RestBottomSheet